import React, { Component } from "react";
import RootAbout from "container/about/RootAbout";

class AboutPage extends Component {
  render() {
    return <RootAbout />;
  }
}

export default AboutPage;
